<template>
    <el-container>
        <el-header>
          <div class="logodiv" style="height: 95px"><img alt="" src="static/lablogo.jpg" width="100%"></div> <div class="regdiv"><span class="logout" @click="onLogout"><i class="el-icon-unlock"></i> 注销[实验老师]</span></div>
        </el-header>
        <el-main>
          <div class="cardrow">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="1"><router-link to="/gaoya/index" style="text-decoration: none;">实验首页</router-link></el-menu-item>
              <el-menu-item index="2"><router-link to="/gaoya/hall" style="text-decoration: none;">仿真实验</router-link></el-menu-item>
              <el-menu-item index="3"><router-link to="/gaoya/upgrade" style="text-decoration: none;">下载升级</router-link></el-menu-item>
              <el-menu-item index="4"><router-link to="/gaoya/teach" style="text-decoration: none;">教学情况</router-link></el-menu-item>
              <el-menu-item index="5">用户中心</el-menu-item>
            </el-menu>
          </div>
          <div><img alt="" src="static/xlabbanner.jpg"></div>
          <div class="cardrow" style="text-align: left;">
            <span><el-tag effect="dark">用户个人中心</el-tag></span>
            <el-divider content-position="right">PERSONAL CENTER</el-divider>
            <el-row :gutter="20">
              <el-col :span="6"><div class="grid-content bg-purple"><el-avatar :size="50" :src="circleUrl"></el-avatar></div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple">昵称：实验老师[teacher]</div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple">
                <el-switch
                  v-model="value1"
                  active-text="中文昵称"
                  inactive-text="用户代码">
                </el-switch>
              </div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
            </el-row>
          </div>
        </el-main>
        <el-footer>
          <el-divider></el-divider>
          系统集成与技术支持：湖南湘交高创信息技术有限公司 
          <el-rate
            v-model="rate"
            disabled
            show-score
            text-color="#ff9900"
            score-template="{value}">
          </el-rate>
        </el-footer>
    </el-container>
</template>


<script>
export default {
  data () {
    return {
      activeIndex: '5',
      currentDate: new Date(),
      rate: 3.9,
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      value1: true
    }
  },
  beforeMount:function(){
    if (!sessionStorage.getItem('user')){
      this.$router.push({path: "/gaoya/login"});
    }
  },
  mounted:function(){
      
  },
  methods: {
    onLogout() {
      this.$confirm('注销将清空实验操作空间, 操作结果是否已上传?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sessionStorage.removeItem("checked");
          this.$router.push({path: "/"});
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      
    },
    handleSelect() {

    },
    handleClick(e) {
      if (e === 0 || e === 2 || e === 3){
        this.$message.error('临时空间不足');
      }else{
        this.$message({
          message: '该步骤无下载项',
          type: 'success'
        });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-header {
    /* background-color: #B3C0D1; */
    color: #333;
    text-align: center;
    line-height: 95px;
    height: 95px !important; 
  }

  .el-footer {
    text-align: center;
    line-height: 35px;
  }
  
  .el-main {
    /* background-color: #0068B7; */
    /* color: #333; */
    text-align: center;
    /* line-height: 160px; */
    width: 100%;
    /* height: 50vh; */
    padding: 0;
    overflow: hidden;
  }

  .logodiv {
    float: left;
    margin-left: 10%;
  }

  .regdiv {
    float: right;
    margin-right: 10%;
  }

  .logout {
    color: #0068B7;
  }

  .logout:hover {
    cursor: pointer;
  }

  .cardrow {
    width: 60%;
    margin: 0 auto;
  }

  .grid-content{
    height: 50px;
    line-height: 50px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/GaoYa/LabPerson.vue